var map = {
	"./cds/4.jpg": "cc7d",
	"./ofresh/4.jpg": "a940",
	"./tq/4.jpg": "596a",
	"./yhnc/4.jpg": "cb38",
	"./ys/4.jpg": "fe2f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1822";